import { SimpleComparer, ReverseAwareComparer } from "./lg-sort-by";

export function toReverseAwareCompare<T>(
    simpleComparer: SimpleComparer<T>
): ReverseAwareComparer<T> {
    return (property1, property2, reverse) =>
        reverse ? -simpleComparer(property1, property2) : simpleComparer(property1, property2);
}
